"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _getInstallmentByOrde;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInstallments = void 0;

var _react = require("react");

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _head = _interopRequireDefault(require("ramda/src/head"));

var _sortWith = _interopRequireDefault(require("ramda/src/sortWith"));

var _prop = _interopRequireDefault(require("ramda/src/prop"));

var _ascend = _interopRequireDefault(require("ramda/src/ascend"));

var _descend = _interopRequireDefault(require("ramda/src/descend"));

var _constants = require("../../../constants");

var _services = require("../../../services");

var _utils = require("../../../utils");

var getFirstByOrder = function getFirstByOrder(comparator, property) {
  return (0, _compose.default)(_head.default, (0, _sortWith.default)([comparator((0, _prop.default)(property))]));
};

var getInstallmentByOrder = (_getInstallmentByOrde = {}, _defineProperty(_getInstallmentByOrde, _constants.OrderBy.MIN, getFirstByOrder(_ascend.default, 'installmentsQuantity')), _defineProperty(_getInstallmentByOrde, _constants.OrderBy.MAX, getFirstByOrder(_descend.default, 'installmentsQuantity')), _getInstallmentByOrde);

var useProductInstallments = function useProductInstallments(_ref) {
  var productType = _ref.productType,
      selectedBy = _ref.selectedBy,
      simulations = _ref.simulations;

  var _ref2 = (0, _react.useState)(simulations),
      _ref3 = _slicedToArray(_ref2, 2),
      installments = _ref3[0],
      setInstallments = _ref3[1];

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      selectedInstallment = _ref5[0],
      setSelectedInstallment = _ref5[1];

  var onSelectInstallment = function onSelectInstallment(installment) {
    setSelectedInstallment(installment);
    (0, _services.dispatchSelectInstallmentEvent)("".concat((0, _utils.getProductLabel)(productType), "_").concat(installment.installmentsQuantity));
  };

  (0, _react.useEffect)(function () {
    if (!simulations || !simulations.length) return;
    var getSelectedInstallment = getInstallmentByOrder[selectedBy];
    setInstallments(simulations);
    setSelectedInstallment(getSelectedInstallment == null ? void 0 : getSelectedInstallment(simulations));
  }, [simulations]);
  return {
    installments: installments,
    selectedInstallment: selectedInstallment,
    onSelectInstallment: onSelectInstallment
  };
};

exports.useProductInstallments = useProductInstallments;